// removed by extract-text-webpack-plugin
module.exports = {"title":"_3mHGIHQ57JjFti5uWcHxJe","chartWrapper":"rd53moKkkziRZ43NU6e0q","chartDescription":"AvgSUoPoW_SZ9CKzVgykh","description":"_17Q-fcNOke9ash2924gpA7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ChartOfViews/ChartOfViews.scss
// module id = 1796
// module chunks = 0